import { defineStore } from "pinia";
import VmsService from "../services/Vms";

// Store Pinia do zarządzania stanem danych VMS (Variable Message Signs)
export const useVmsStore = defineStore({
  id: "vms",
  state: () => ({
    groupStatuses: {},      // Statusy wszystkich grup znaków VMS (np. czy włączone/wyłączone)
    groupDescriptions: {},  // Opisy grup VMS (np. nazwy, lokalizacje)
    isLoaded: false,        // Flaga - czy dane zostały już załadowane
    isLoading: false,       // Flaga - czy obecnie trwa ładowanie danych
  }),

  actions: {
    /**
     * Pobiera statusy i opisy grup VMS z backendu (tylko jeśli nie zostały już pobrane lub nie trwa pobieranie)
     */
    async loadData() {
      if (this.isLoaded || this.isLoading) return; // Zabezpieczenie przed wielokrotnym ładowaniem

      this.isLoading = true;
      try {
        // Pobierz statusy i opisy grup VMS z serwisu
        const [statuses, descriptions] = await VmsService.getAllGroupStatus();
        this.groupStatuses = statuses;
        this.groupDescriptions = descriptions;
        this.isLoaded = true; // Oznacz jako załadowane
      } catch (error) {
        // Obsługa błędu - wyświetl w konsoli
        console.error("Błąd podczas ładowania danych VMS:", error);
      } finally {
        this.isLoading = false;
      }
    }
  },
});

// Obsługa Hot Module Replacement dla Pinia (tylko podczas developmentu)
// if (typeof import.meta !== 'undefined' && import.meta.hot) {
//   import.meta.hot.accept(acceptHMRUpdate(useVmsStore, import.meta.hot));
// }
